import { useEffect, useState } from 'react';
import { omsV2Client, resolve, ImResponse } from 'services/api';
import { ScoreLabelCode } from './model';
export interface ScoreDictionary {
  dictionaryVersion: number;
  maxDelayMin: number;
  v2WriteEnabled: boolean;
  labels: { labelCode: ScoreLabelCode; name: string; concept: Marketing.Concept }[];
}
export function useScoreDictionary(enabled = true) {
  const [dictionary, setDictionary] = useState<ScoreDictionary>();
  const [failed, setFailed] = useState(false);
  useEffect(() => {
    if (!enabled) return undefined;
    let active = true;
    resolve(omsV2Client.get<ImResponse<ScoreDictionary>>('/reception-score/labels'))
      .then((data) => {
        if (active) setDictionary(data);
      })
      .catch(() => {
        if (active) setFailed(true);
      });
    return () => {
      active = false;
    };
  }, [enabled]);
  return { dictionary, failed };
}
